import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { GeneralPowerIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InputLabel } from "@material-ui/core";

export const AdjustableLoadElectricSharedElectricityForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_SHARED_ELECTRICITY>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<GeneralPowerIcon />}
                content={
                    <>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Allgemeinstrom in Mehrfamilienhäusern
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            z. B. Treppenhausbeleuchtung
                        </p>
                    </>
                }
                useSwitch={
                    <Switch
                        checked={values.adjustableLoadElectricSharedElectricity.value.installed}
                        {...getFieldProps("adjustableLoadElectricSharedElectricity.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.adjustableLoadElectricSharedElectricity.value.installed = checked;
                                values.adjustableLoadElectricSharedElectricity.value.demand.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.adjustableLoadElectricSharedElectricity.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            decimalScale={
                                values.adjustableLoadElectricSharedElectricity.value.demand.precision
                            }
                            allowLeadingZeros={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.adjustableLoadElectricSharedElectricity.value.demand.unit}
                            value={
                                values.adjustableLoadElectricSharedElectricity.value.demand.amount || ""
                            }
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.adjustableLoadElectricSharedElectricity.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.adjustableLoadElectricSharedElectricity.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
